import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders, uaeProjectsBaseURL } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { CREATE_AIRPORT_TRANSFER_BOOKING, CREATE_AIRPORT_TRANSFER_BOOKING_ERROR, CREATE_AIRPORT_TRANSFER_BOOKING_SUCCESS } from '../../actions';
import { Constant } from '../../../../../Containers/Helpers/constant.js';
import cogoToast from 'cogo-toast';

const getCurrentTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

function* createAirportTransferBooking({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/vendor/bookings`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        ...(Constant?.PROJECT_CODE === `MASTERCARD_KSA` && {
          'x-timezone': getCurrentTimezone(),
          'x-timezone-offset': new Date().getTimezoneOffset(),
        }),
      },
      params: {
        ...payload?.urlParams,
      },
      data: {
        ...payload?.data,
      },
    });

    if (response?.status === 200) {
      yield put({
        type: CREATE_AIRPORT_TRANSFER_BOOKING_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: CREATE_AIRPORT_TRANSFER_BOOKING_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_AIRPORT_TRANSFER_BOOKING_ERROR, payload: error });
  }
}

export function* watchCreateAirportTransferBooking() {
  yield takeEvery(CREATE_AIRPORT_TRANSFER_BOOKING, createAirportTransferBooking);
}

function* createAirportTransferBookingSaga() {
  yield all([fork(watchCreateAirportTransferBooking)]);
}

export default createAirportTransferBookingSaga;
